import { Moment } from "moment";
import Utils from "../utils";
import { SyncModel, SyncDataModel, DataModel } from "./syncModel";
import { InternationalisationService } from "../../forked/angular-internationalisation";

export class NewsDetailViewModel {
  public id: number;
  public dateYMD: number;
  public date: string;
  public day: string;
  public month: string;
  public year: string;
  public momentDate: Moment;
  public label_de?: string;
  public label_en?: string;
  public get label(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.label_en) ? this.label_de : this.label_en;
  }
  public text_de: string;
  public text_en: string;
  public get text(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.text_en) ? this.text_de : this.text_en;
  }
  public image_photo: string;
  public rate: number;
  public like: boolean;
}

export class NewsViewModel {
  public id: number;
  public dateYMD: number;
  public date: string;
  public day: string;
  public month: string;
  public year: string;
  public yearLastDig: string;
  public momentDate: Moment;
  public label_de?: string;
  public label_en?: string;
  public get label(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.label_en) ? this.label_de : this.label_en;
  }
  public text_de: string;
  public text_en: string;
  public get text(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.text_en) ? this.text_de : this.text_en;
  }
  public image_photo: string;
  public locations: number[];
  public like: boolean;
}

// Requests
export class NewsSyncModel extends SyncModel {
}

// Responses
export class NewsDataModel extends DataModel {
  public get DM_Key(): number | string { return this.id; }
  public id: number;
  public release: boolean;
  public public: boolean;
  public date_ymd: number;
  public get date(): Moment {
    return Utils.GetMomentFromInt(this.date_ymd, 0);
  }
  public label_de: string;
  public label_en: string;
  public text_de: string;
  public text_en: string;
  public last_image_update_at_ymd: number;
  public last_image_update_at_hms: number;
  public get last_image_update_at(): Moment {
    return Utils.GetMomentFromInt(this.last_image_update_at_ymd, this.last_image_update_at_hms);
  }
  public locations: number[];
  public deleted: boolean;
  public change_at_ymd: number;
  public change_at_hms: number;
  public get change_at(): Moment {
    return Utils.GetMomentFromInt(this.change_at_ymd, this.change_at_hms);
  }
  public change_by: number;
}

export class NewsSyncDataModel extends SyncDataModel {
  public news: NewsDataModel[];
  public get models(): DataModel[] { return this.news; }
  public DeserializeType(): void {
    this._DeserializeType(NewsDataModel);
  }
}
